<template>
  <v-navigation-drawer
      fixed
      color="secondary-card"
      :permanent="!isMobile"
      clipped
      :app="isMobile"
      v-model="drawer"
      floating
      :expand-on-hover="!isMobile"
      :mini-variant.sync="mini"
  >



    <v-list class="mt-12" nav dense subheader color="transparent">

      <v-subheader >{{ mini ? '' : 'General' }}</v-subheader>
      <template v-for="(item, i) in userItems">
        <v-list-item active-class="primary white--text" link :to="item.link" :key="i+'general'" @click="goTo(item.link)">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>

    <v-divider></v-divider>

    <v-list nav dense subheader color="transparent">

      <v-subheader v-if="providerItems.length > 0">{{ mini ? '' : 'Proveedor' }}</v-subheader>

      <template v-for="(item, i) in providerItems">

        <v-list-group
            :prepend-icon="item.icon"
            v-if="item.children"
            :key="`${i}-children-group`"
        >
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
              v-for="(child, j) in item.children"
              @click="drawer=false"
              :to="child.link"
              :key="`${i}-${j}`"
          >
            <v-list-item-icon>
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ child.title }}</v-list-item-title>
          </v-list-item>

        </v-list-group>

        <template v-else>
          <v-list-item active-class="primary white--text" link :to="item.link" :key="i+'provider'" @click="goTo(item.link)">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </template>

      </template>
    </v-list>

    <v-divider v-if="providerItems.length > 0" class="mt-4"></v-divider>

    <v-list  nav dense subheader color="transparent">
      <v-subheader >{{ mini ? '' : 'Configuraciones' }}</v-subheader>
      <template v-for="(item, i) in configs">
        <v-list-item v-if="hasAccess(item.link.name)" active-class="primary white--text" link :to="item.link" :key="i+'general'" @click="goTo(item.link)">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>

    <v-divider light></v-divider>

    <v-list nav dense v-if="superItems.length > 0" color="transparent">
      <v-subheader >{{ mini ? '' : 'Admin' }}</v-subheader>

      <template v-for="(item, i) in superItems">

        <v-list-group
            class="menu-group"
            :prepend-icon="item.icon"
            v-if="item.children"
        >
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
              v-for="(child, j) in item.children"
              @click="drawer=false"
              :to="child.link"
              :key="`${i}-${j}`"
              class="pl-2"
          >
            <v-list-item-avatar>
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-avatar>
            <v-list-item-title>{{ child.title }}</v-list-item-title>
          </v-list-item>

        </v-list-group>

        <v-list-item active-class="primary white--text" v-else :to="item.link" :key="i+'admin'" @click="goTo(item.link)">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>

    <v-divider></v-divider>
    <v-list color="transparent">
      <v-list-item link @click="setLogoutVisibility">
        <v-list-item-icon>
          <v-icon>mdi-logout</v-icon>
        </v-list-item-icon>
        <v-list-item-title>Salir</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import ThemeMixin from "@/mixins/ThemeMixin";
import MenuMixin from "../../../mixins/MenuMixin";

export default {
  props: ['show'],
  components: {},
  mixins: [ThemeMixin, MenuMixin],
  data() {
    return {
      drawer: this.show,
      mini: true,
      right: null,
    }
  },
  mounted(){
    const vm = this
    vm.mini = !vm.isMobile
  },
  watch: {
    breakPoint(val){
      const vm = this

      if(val === 'xs' || val === 'sm'){
        vm.mini = false
        return
      }

      return vm.mini = true

    },
    mini(val){
      const vm = this
      if(val) vm.drawer = false
    },
    currentUser(val) {
      this.drawer = Boolean(this.drawer)
    },
    show(val) {
      this.drawer = val
    },
    drawer(val) {
      this.$emit('change', val)
    }
  },
}
</script>

<style scoped>

>>>.v-sheet.v-list {
  padding: 5px;
}

.menu-bg {
  position: fixed;
  background-size: cover;
  opacity: .3;
  background-position: left;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.menu-group {
  padding-left: 10px;
}

>>> .menu-group .v-list__tile:first-child {
  padding-left: 5px !important;
}


</style>
